import axios from 'axios';

/**
 * Shared state/action shape for Pinia stores that list paged results from a
 * `GET <endpoint>` returning `{ items, count }` - the pattern already used
 * independently by Fixed Fees, Time Entries, and Matters. Domain stores
 * spread these into their own defineStore state()/actions instead of
 * re-implementing the same fetch/loading/error boilerplate. Each domain
 * keeps owning its own filter-building logic (query params vary too much
 * per page to share); this only covers the fetch itself.
 */
export interface PagedListState {
  items: any[];
  totalCount: number;
  loading: boolean;
}

export function pagedListState(): PagedListState {
  return {
    items: [],
    totalCount: 0,
    loading: false,
  };
}

interface PagedListStoreContext {
  loading: boolean;
  items: any[];
  totalCount: number;
  handleError: (error: unknown) => void;
}

export function pagedListActions(endpoint: string) {
  return {
    async list(this: PagedListStoreContext, params: Record<string, unknown> = {}) {
      this.loading = true;
      try {
        const response = await axios({ method: 'GET', url: endpoint, params });
        this.items = response.data.items;
        this.totalCount = response.data.count;
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },
  };
}
